<template>

    <div class="dd-m-card dd-m-card--users-rankings" v-if="item">
        <div class="dd-m-extra--section-header">
            <h3 v-if="item.titles" class="dd-m-extra--section-header__title">{{item.titles.title}}</h3>

            <span class="dd-m-helper--detail-row"></span>
        </div>

        <graphic-lines v-if="item.type === 1" :item="item"></graphic-lines>
        <graphic-radial v-if="item.type === 2" :item="item"></graphic-radial>
    </div>

</template>
<script>
    import GraphicLines from "../graphics/graphic-lines";
    import GraphicRadial from "../graphics/graphic-radial";

    export default {
        name: 'card-users-rankings',
        components: {GraphicRadial, GraphicLines},
        props: ['item'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-users-rankings.vue